import React from 'react';

import '../less/style.less';

export default function App({ children }) {
  return (
    <div className="market-app-root">
      <div className="view-wrap">{children}</div>
    </div>
  );
}
